// Copyright (c) 2021. Sendanor <info@sendanor.fi>. All rights reserved.

import React from "react";
import ModalService, { ModalDestructor } from "../nor/ui/services/ModalService";
import ModalType from "../nor/ui/services/types/ModalType";
import LogService from "../nor/ts/LogService";
import PipelineRunMonitor from "../components/common/pipeline/run/monitor/PipelineRunMonitor";

const LOG = LogService.createLogger('PipelineRunMonitorModal');

export class PipelineRunMonitorModal {

    private static _monitorModal : ModalDestructor | undefined;

    public static destroy () {
        this.closeModal();
    }

    public static isOpen () : boolean {
        return this._monitorModal !== undefined;
    }

    public static closeModal () {
        if (this._monitorModal) {
            this._monitorModal();
            this._monitorModal = undefined;
        }
    }

    public static openModal (
        pipelineId : string,
        runId      : string
    ) {

        // FIXME: Handle state where the modal was already open with a warning line and do not re-open
        this.closeModal();

        LOG.debug('Creating pipeline run monitor modal for ', pipelineId, runId);

        this._monitorModal = ModalService.createModal(
            (
                <PipelineRunMonitor
                    pipelineId={pipelineId}
                    runId={runId}
                />
            ),
            ModalType.CENTER
        );

    }

}

export default PipelineRunMonitorModal;
